import React, { useState } from "react";
import "./TrainingCard.scss";
import {
  ScheduleOutlined,
  DeleteOutlined,
  EditOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import IconTag from "../../../../components/IconTag/IconTag";
import Card from "../../../../components/Card/Card";
import { Popconfirm, Rate, Tooltip } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { checkUserRole } from "../../../../core/utils/helpers";
import useAuth from "../../../../core/hooks/useAuth";
import ModalEditTraining from "../TrainingCardList/components/ModalEditTraining/ModalEditTraining";
import dayjs from 'dayjs';


const fullName = (firstName, lastName) => {
  return firstName + " " + lastName;
};

function TrainingCard({
  id,
  start_date,
  end_date,
  course,
  trainer,
  nameSection,
  handleDeleteTraining,
  trainingRating,
  isUpcomingTraining
}) {
  const navigate = useNavigate();
  const navigateToTraining = () => {
    return () => {
      navigate("/TrainingDetails/" + id);
    };
  };
  const navigateToTrainerProfile = (id) => {
    return () => {
      navigate("/profile/" + id);
    };
  };


  const [isModalEditOpen, setIsModaEditOpen] = useState(false);


  const handleEditClick = () => {
    setIsModaEditOpen(true);
  };

  const cancel = (e) => {
    e.stopPropagation();
  };


  let imgOrigin = `${process.env.REACT_APP_CORE_PATH}/courses/images/${course?.imagePath}`;
  let userImg = `${process.env.REACT_APP_CORE_PATH}/users/avatars/${trainer?.image}`;
 
  const { authenticatedUser } = useAuth();

  function calculateBusinessDaysDifference(startDate, endDate) {
    const startDateObject = new Date(startDate);
    const endDateObject = new Date(endDate);

    const timeDifference = endDateObject - startDateObject;

    const dayDifference = timeDifference / (1000 * 60 * 60 * 24);

    let businessDays = 0;
    for (let i = 0; i <= dayDifference; i++) {
      const currentDate = new Date(startDateObject);
      currentDate.setDate(startDateObject.getDate() + i);

      if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) {
        businessDays++;
      }
    }

    return businessDays;
  }

  const avatarUrls = [
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTBmCMAdDMUMWg11cGTvr-GOq72-Qi49JgZfUA2cffElOTKYZi3RVxUFJ_tzzzbk8F6_z8&usqp=CAU",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQeJnuSzLJ_pnB1vY08vn3RSbsfT0KpmTGWkltv0G3g-RC0OQHjM61dQNkgs7y4KkbiBHE&usqp=CAU",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqAlN5bl2UIns-BmE8rqnEcVvF3eco4EiUwTPlKKfscZTDiX446E8bzDcW2ukxZ4-SySI&usqp=CAU",
  ];

  const getRandomAvatarUrl = () => {
    const randomIndex = Math.floor(Math.random() * avatarUrls.length);
    return avatarUrls[randomIndex];
  };

const unixTimestamp = dayjs(start_date).unix();
const startDateToUnix = dayjs.unix(unixTimestamp).format('YYYY-MM-DD');

  return (
    <div className="training-card">
      <Card>
        <div
          className="card-image"
          style={{
            backgroundImage: imgOrigin
              ? `url(${imgOrigin})`
              : "https://www.pulsecarshalton.co.uk/wp-content/uploads/2016/08/jk-placeholder-image.jpg",
          }}
          onClick={navigateToTraining()}
        >
          <div className="image-modal">
            <button onClick={navigateToTraining}>Preview {nameSection}</button>
          </div>
        </div>
        <div className="top-section">
          <p>{course?.category || "None"}</p>
          <div className="icons-row">
            <IconTag
              Icon={CalendarOutlined}
              title={startDateToUnix}
              tooltipText="Start Date"
            />
            <IconTag
              Icon={ScheduleOutlined}
              title={`${
                calculateBusinessDaysDifference(start_date, end_date) || 0
              } Days`}
              tooltipText="Number of days"
              color={"#185993"}
            />
          </div>
        </div>
        <div className="middle-section">
          <h3>{course?.title || "None"}</h3>
          { checkUserRole(authenticatedUser, ["Admin", "Trainer"],
          <div className="icons-row">
            <EditOutlined className="editIcon" onClick={handleEditClick} />
            <ModalEditTraining
              isModalEditOpen={isModalEditOpen}
              setIsModalEditOpen={setIsModaEditOpen}
              idTraining={id}
              isUpcomingTraining={isUpcomingTraining}
            />
            <Popconfirm
              title="Delete the training"
              description="Are you sure to delete this training ?"
              onConfirm={(e) => handleDeleteTraining(id, e)}
              onCancel={(e) => cancel(e)}
              okText="Yes"
              cancelText="No"
            >
              <>
                <Tooltip placement="bottomLeft" title="Delete training">
                  <DeleteOutlined className="trashIcon" />
                </Tooltip>
              </>
            </Popconfirm>
          </div>
          )
              }
        </div>
        <div className="bottom-section">
          <h4>{course?.description || "None"}</h4>
          <div className="trainer-info">
            <img
              src={trainer?.image ? userImg : getRandomAvatarUrl()}
              alt="card"
              // onClick={navigateToTrainerProfile(trainer?.id)}
            />
            <div>
              {/* this is a temporary for navigating to the trainer profile due to the lack of backend functionality */}
              <Link to={"/trainer-profile"} className="trainer-name">
                {fullName(trainer?.firstName, trainer?.lastName) || "Unknown"}
              </Link>
              <span className="trainer-label" >Trainer</span>
              {/* <span className="trainer-name" onClick={navigateToTrainerProfile(trainer?.id)}>
              {fullName(trainer?.firstName, trainer?.lastName) || "Unknown"}
              </span>
              <span className="trainer-label" onClick={navigateToTrainerProfile(trainer?.id)}>Trainer</span>  */}
            </div>
          </div>
        </div>
        <div className="trainer-rating">
           <Rate
              disabled
              defaultValue={trainingRating ?? 0}
            />
        </div>
      </Card>
    </div>
  );
}

export default TrainingCard;
